import { lazy } from 'react';
import reducer from './state/reducers';
import { getStore } from '@AppRedux/store';
import checkAuth from '@Utils/checkAuth';

const store = getStore();

const InterviewsList = lazy(() =>
    import('./InterviewsList').then(async module => {
        await checkAuth();
        const auth = getStore().getState().auth;
        if(auth.isAuthenticated) {
            store.injectReducer('interviewsList', reducer.listReducer);
            return module;
        }
    })
);

const InterviewsAdd = lazy(() =>
    import('./InterviewsAdd').then(async module => {
        await checkAuth();
        const auth = getStore().getState().auth;
        if(auth.isAuthenticated) {
            store.injectReducer('interviewsAdd', reducer.addReducer);
            return module;
        }
    })
);


const InterviewsDetail = lazy(() =>
    import('./InterviewsDetail').then(async module => {
        await checkAuth();
        const auth = getStore().getState().auth;
        if(auth.isAuthenticated) {
            store.injectReducer('interviewsDetail', reducer.detailReducer);
            return module;
        }
    })
);

const InterviewsRoutes = [
    {
        label: 'Interviews',
        path: '/HRAutomation/Interviews',
        menuName: 'hrAutomation',
        component: InterviewsList,
        icon: 'fa-user',
        exact: true,
        showNav: true, 
        public: true, 
    },
    {
        label: 'Interviews',
        path: '/HRAutomation/Interviews/Add',
        component: InterviewsAdd,
        icon: 'fa-user',
        exact: true,
        showNav: false, 
        public: true,
    },
    {
        label: 'Interviews',
        path: '/HRAutomation/Interviews/:mode/:id',
        component: InterviewsDetail,
        exact: true,
        showNav: false, 
        public: true,
    },
]

export default InterviewsRoutes;